import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Component from './FigureConsum.Component';

type FigureConsumProps = {
    logo?:any,
    SI?:string,
    description?:string,
    bold?:string,
    numberBcn?: number
    numberJam?: number
}

const mapStateToProps = (state:any,props:FigureConsumProps) => {
    return createStructuredSelector<any,any>({

    });
};

const mapDispatchToProps = {
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Component);